/**
 * @file
 * Global utilities.
 *
 */
(function (window, $) {
  var bodyElement = $('body');
  var position = $(window).scrollTop();
  var checkDruidChat = true;
  var druidTooltip = $('#druidContainerTooltip');
  var druidTooltipLSKey = 'd8_druidchat_tooltip_seen';
  var druidTooltipMillisecondsThreshhold = 2 * 60000; // 2 minutes
  var druidTimeoutSet = false;
  /**
   * Returns true if the viewport width is ≤768px.
   * @return {boolean}
   */
  window.isMobile = function () {
    return window.innerWidth <= 1376;
  };
  (function () {
    var ua = navigator.userAgent || '';
    var isIpadOSDesktopUA = ua.indexOf('Macintosh') !== -1
      && ua.indexOf('Version/') !== -1
      && ua.indexOf('Mobile/') !== -1;
    var isTablet = /iPad|Tablet|PlayBook|Silk/i.test(ua)
      || (/Android/i.test(ua) && !/Mobile|Mini/i.test(ua))
      || isIpadOSDesktopUA;
    var isPhone = !isTablet && /Mobi|iPhone|iPod|Android|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(ua);
    var deviceClass = isTablet ? 'client-is-tablet' : (isPhone ? 'client-is-phone' : 'client-is-desktop');

    document.documentElement.classList.add(deviceClass);
  })();
  window.makeItemVisible = function ($container, scrollingContainer, activeItem) {
    var $activeItem = $container.find(activeItem);
    if (!$activeItem.length) {
      return;
    }

    var isItemInVIewport = isInViewport($activeItem);

    if (isItemInVIewport) {
      return;
    }

    $container.find(scrollingContainer).scrollLeft($activeItem.offset().left);
  };

  /** check horizontally viewport */
  window.isInViewport = function ($element) {
    var windowWidth = $(window).width(),
      elementWidth = $element.outerWidth(),
      elementLeft = $element.offset().left,
      visibleOffset = (windowWidth / 2) - (elementWidth / 2),
      hideOffset = visibleOffset - elementWidth;

    return elementLeft <= visibleOffset && elementLeft >= hideOffset;
  };
  window.checkDruidTooltip = function () {
    var lastSeenTooltip = window.localStorage.getItem(druidTooltipLSKey);
    var timestampNow = Date.now();

    if (!(lastSeenTooltip && (timestampNow - lastSeenTooltip < druidTooltipMillisecondsThreshhold))) {
      druidTooltip.stop().fadeIn();
      $('#druidContainerElement').addClass('has-tooltipActive');
    }
    druidTimeoutSet = false;
  };

  window.hideDruidTooltip = function () {
    $('#druidContainerElement').removeClass('has-tooltipActive');
    druidTooltip.stop().fadeOut();
    window.localStorage.setItem(druidTooltipLSKey, Date.now().toString());
    setTimeout(checkDruidTooltip, druidTooltipMillisecondsThreshhold + 3000);
    druidTimeoutSet = true;
  };
  // --- setup once ---
  var bodyElement = $('body');
  var position = 0;                // last scrollY
  var checkDruidChat = true;       // keep your flag
  var druidTooltip = $('#druid-tooltip'); // or however you select it

  // Read scrollY robustly (works on iOS/Android/desktop, with sticky bars)
  function getScrollY() {
    return window.pageYOffset
      || (document.scrollingElement && document.scrollingElement.scrollTop)
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
  }

  // One-screen height that matches what the user actually sees on mobile
  function getViewportHeight() {
    return (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  }

  // rAF throttle so we don’t run your code dozens of times per frame
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      window.sticky();            // run your logic
      ticking = false;
    });
  }

  // Bind to real scroll targets
  window.addEventListener('scroll', onScroll, { passive: true });
  // If your layout scrolls inside a container (common on mobile), bind those too:
  document.querySelectorAll('.page-wrapper, .scroll-container')
    .forEach(function (el) {
      el.addEventListener('scroll', onScroll, { passive: true });
    });

  // Re-run on resize / orientation change (address-bar changes can shift thresholds)
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('orientationchange', onScroll, { passive: true });

  // Run once on load
  document.addEventListener('DOMContentLoaded', function () {
    window.sticky();
  });

  window.sticky = function () {
    var scroll = getScrollY();                 // <— robust scrollY
    var oneScreen = getViewportHeight();       // <— robust viewport height

    // console.log(scroll);

    if (scroll > 90) {
      bodyElement.addClass('scrolled').removeClass('scrolled-20');
    } else if (scroll > 80) {
      bodyElement.addClass('scrolled-20').removeClass('scrolled');
    } else {
      bodyElement.removeClass('scrolled scrolled-20');
    }

    if (scroll > oneScreen) {                  // <— was $(window).height()
      bodyElement.addClass('scrolled-one-screen');

      if (checkDruidChat) {
        if (!$('#druidWebchatRoot').length) {
          bodyElement.addClass('no-druid-chat');
        } else {
          bodyElement.removeClass('no-druid-chat');
          checkDruidChat = false;
        }
      }

      $('#rm-back-to-top').fadeIn();
      if (druidTooltip.length && druidTooltip.is(':visible') && !window.druidTimeoutSet) {
        hideDruidTooltip();
      }
    } else {
      bodyElement.removeClass('scrolled-one-screen');
      $('#rm-back-to-top').fadeOut();
    }

    if (scroll > position) {
      bodyElement.addClass('scrolldown').removeClass('scrollup');
    } else {
      bodyElement.addClass('scrollup').removeClass('scrolldown');
    }
    position = scroll;
  };


  window.bodyScrollable = function (scrollable) {
    var scrollPosition = 0;

    if (!scrollable) {
      isBodyScrollable = false;
      scrollPosition = $(window).scrollTop();
      bodyElement.css({ width: '100%', overflow: 'hidden', position: 'fixed', top: '-' + scrollPosition + 'px' });
      if (scrollPosition > 50) {
        bodyElement.addClass('scrolled-fixed');
      }
    } else {
      $('body').removeClass('modal-open');
      scrollPosition = bodyElement.position().top;
      isBodyScrollable = true;
      bodyElement.css({ width: '', overflow: '', position: '', top: '' });
      window.scrollTo(0, Math.abs(scrollPosition));
      bodyElement.removeClass('scrolled-fixed');
    }
  };

  window.checkLocationSelect = function (selectElement) {
    var childIsSelected = selectElement.find('option:selected').hasClass('child');

    if (childIsSelected) {
      selectElement.addClass('has-child-selected');
    } else {
      selectElement.removeClass('has-child-selected');
    }
  };

  window.focusInput = function (elementWithOpenClass) {
    // this solution overcomes IE issues that lead to cursor being wrongfully placed in the page
    if (elementWithOpenClass.hasClass('is-open')) {
      var inputElement = elementWithOpenClass.find('input.form-control.form-search');
      var inputValue = inputElement.val();
      var cursorPosition = inputValue && inputValue !== '' ? inputValue.length : 0;
      if (inputElement.length > 0) {
        inputElement[0].focus();
        inputElement[0].setSelectionRange(cursorPosition, cursorPosition);
      }
    }
  };

  window.handleCustomTitle = function ($customTitle) {
    var titleHeight;
    var $closestTitle = $customTitle.parents('.field--name-field-description').prev('.field--name-field-title');

    if (!$closestTitle.length) {
      return;
    }

    titleHeight = $closestTitle.outerHeight();

    /* handle if subtitle */
    if ($closestTitle.parent().find('.field--name-field-subtitle').length) {
      titleHeight += $closestTitle.parent().find('.field--name-field-subtitle').height() || 0;
    }

    if ($closestTitle.parents('.section-intro').length) {

      if ($(window).width() <= 1272) {
        $customTitle.css('top', titleHeight - 6 + 'px');
      } else {
        $customTitle.css('top', titleHeight - 19 + 'px');
      }

      return;
    }

    if ($closestTitle.parents('.section-appointment').length && $(window).width() <= 1272) {
      $customTitle.css('top', '-' + (titleHeight + 4) * 2 + 'px');

      return;
    }

    $customTitle.css('top', titleHeight + 'px');
  };
  // show more text - header image component
  window.handleDescription = function (headerImageSelector, descriptionSelector) {
    var $headerImageComponent = $(headerImageSelector);

    if (!$headerImageComponent.length) {
      return;
    }

    var $description = $headerImageComponent.find(descriptionSelector);
    var chars = $description.text();

    if (!chars.length || chars.length <= 169) {
      return;
    }

    $description.hide();

    var charsToShow = chars.split('').slice(0, 169).join('');
    $description.text(charsToShow);

    var $descriptionBtn = $('<span>...</span><span class="show-more">mai mult.</span>')
      .on('click', function (event) {
        $(event.target)
          .closest(descriptionSelector)
          .text(chars)
          .show()
        ;
      });

    $description
      .append($descriptionBtn)
      .show();
  };

  window.addActiveClassToLinks = function () {
    // Get the current URL.
    const currentURL = window.location.href;
    // Select the specific menu block.
    const menuBlock = $('#block-ponderasenmenu');
    // Select all links within the menu block.
    const menuLinks = menuBlock.find('a');
    // Iterate through each link and check if it matches any part of the current URL.
    menuLinks.each(function () {
      const linkURL = $(this).attr('href');
      // Check if the current URL contains the link's URL.
      if (currentURL.includes(linkURL)) {
        const hp = linkURL.split('/');
        const firstSegment = '/' + hp[1] + '/' + hp[2];
        if (linkURL !== firstSegment) {
          $(this).addClass('active');
        }
      }
    });
  };

})(window, jQuery);

(function ($, Drupal) {
  'use strict';
  if (!isMobile()) {
    var image_height = $('.split_70_30 .column:nth-child(2) .field--name-field-second-column').height();
    $('.split_70_30 .column .paragraph--type--component-image img').height(image_height);
  }
  window.debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  };


  Drupal.behaviors.regina_maria = {
    attach: function (context) {
      if(isMobile()){
        document.querySelectorAll('.fc-title').forEach(el => {
          const m = el.textContent.trim().match(/^(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})$/);
          if (!m) return;
          el.dataset.from = m[1];
          el.dataset.to   = m[2];
          el.classList.add('time-stack');
        });
        $(once('locations-sidebar-close-menu', '.region-sidebar-first .menu--location .nav')).prepend('<li class="articles_mobile_close"><span class="icon-close close-main"></span></li>');
        $(once('locations-sidebar-close-button', '.articles_mobile_close', context)).on('click', function () {
          $('.menu--location').removeClass('is-expanded');
          $('.articles_mobile_close').hide();
        });
        $(once('menu-toggle', '.menu--location .nav li.has-children', context)).on('click', function () {
          var $parent = $(this).closest('.nav-item');
          // Toggle class and submenu visibility
          $(this).toggleClass('is-opened');
          $('.articles_mobile_close').show();
        });
      }
      var bodyElement = $('body');
      var isBodyScrollable = true;
      //scrolled-20 is used to know when to hide CTA's on mobile, 'scrolled' is added too late after they overlap elements

      var druidTooltip = $('#druidContainerTooltip');
      if (druidTooltip.length > 0) {
        druidTooltip.stop().fadeIn();
        $('#druidContainerElement').addClass('has-tooltipActive');
      }
      if(!isMobile()) {
        sticky();

        $(window).off('scroll.reginaMariaSticky').on('scroll.reginaMariaSticky', function () {
          sticky();
        });
      }

      //prevent scroll on confirmation page if not campaign page
      var webformConfirmation = $('.webform-confirmation');
      var isCampaignPage = !!$('.node--type-campaign').length;

      if (webformConfirmation.length > 0 && !isCampaignPage) {
        bodyScrollable(false);
      }

      //prevent scroll on campaign confirmation page if breakpoint down md
      if (webformConfirmation.length && isCampaignPage && $(window).width() < 1225) {
        bodyScrollable(false);
      }

      $(once('field-tooltip', '.field-tooltip', context)).on('click', function () {
        $(this).toggleClass('is-expanded');
        bodyElement.toggleClass('modal-open');
      });

      $('.edu-categories-choose-section', context).on('click', function () {
        $(this).parents('.block-edu-categories').toggleClass('is-expanded');

        if ($(this).parents('.block-edu-categories').hasClass('is-expanded')) {
          bodyScrollable(false);
        } else {
          bodyScrollable(true);
        }
      });

      $(once('back-to-top', '#rm-back-to-top', context)).on('click', function (e) {
        e.preventDefault();
        $('html, body').stop().animate({
          scrollTop: 0,
        }, 1000);
      });
      // disable scroll on body if overlay open
      $(once('addtoany-share', '.addtoany_share', context)).on('click', function () {
        bodyScrollable(false);
      });

      setTimeout(function () {
        // enable scroll on body on overlay close
        $(once('a2a-overlay', '.a2a_overlay', context)).on('click', function (event) {
          var a2amenu = $('.a2a_full *');

          if (!$(event.target).is(a2amenu)) {
            bodyScrollable(true);
          }
        });

        window.onkeydown = function (event) {
          if (event.keyCode !== 27) {
            return;
          }

          if (jQuery('#a2apage_full').is(':visible')) {
            bodyScrollable(true);
          }
        };
      }, 300);

      function updateArticleMenuZIndexByAuthorsPosition() {
        var $articleMenuNav = $('.region-sidebar-first .block-article-news-menu');
        var $authorsBlock = $('.block-authors-list, .authors-area').first();

        if (!$articleMenuNav.length || !$authorsBlock.length || $(window).width() > 1199) {
          $articleMenuNav.css({ 'z-index': '' });
          return;
        }

        var rect = $authorsBlock[0].getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var isAuthorsVisible = rect.bottom > 0 && rect.top < viewportHeight;

        $articleMenuNav.css({ 'z-index': isAuthorsVisible ? '0' : '' });
      }

      $(window).off('scroll.authorsNavZIndex resize.authorsNavZIndex')
        .on('scroll.authorsNavZIndex resize.authorsNavZIndex', updateArticleMenuZIndexByAuthorsPosition);
      updateArticleMenuZIndexByAuthorsPosition();

      once('authors-global-handlers', 'body', context).forEach(function () {
        $(document)
          .off('.authorsDropdown')
          .on('click.authorsDropdown', '.block-authors-list .multiple-authors-dropdown, .authors-area .multiple-authors-dropdown', function (e) {
            var $currentDropdown = $(this);
            var $currentAuthorsArea = $currentDropdown.closest('.authors-area, .block-authors-list');
            var $currentCollapse = $currentAuthorsArea.find('.collapse');
            var $articleMenuNav = $('.region-sidebar-first .menu--article-news .nav-list-wrapper');
            var isCurrentlyOpen = $currentCollapse.hasClass('show') || $currentCollapse.hasClass('collapsing');

            $('.authors-area, .block-authors-list').not($currentAuthorsArea).css({ 'z-index': '1', 'position': 'relative' });
            $currentAuthorsArea.css({ 'z-index': '1000', 'position': 'relative' });
            $currentCollapse.css({ 'z-index': '1001', 'position': 'absolute' });
            if ($articleMenuNav.length) {
              $articleMenuNav.css({ 'z-index': '0' });
            }

            var hasOthersOpen = false;
            $('.authors-area .collapse.show, .authors-area .collapse.collapsing, .block-authors-list .collapse.show, .block-authors-list .collapse.collapsing').each(function () {
              var $otherCollapse = $(this);
              var $otherAuthorsArea = $otherCollapse.closest('.authors-area, .block-authors-list');
              if (!$otherAuthorsArea.is($currentAuthorsArea)) {
                hasOthersOpen = true;
                if (window.bootstrap && window.bootstrap.Collapse) {
                  var collapseInstance = window.bootstrap.Collapse.getInstance($otherCollapse[0]);
                  if (collapseInstance) {
                    collapseInstance.hide();
                  }
                }
                else {
                  var $otherDropdown = $otherAuthorsArea.find('.multiple-authors-dropdown');
                  if ($otherDropdown.length && !$otherDropdown.hasClass('collapsed')) {
                    $otherDropdown[0].click();
                  }
                }
              }
            });

            if (hasOthersOpen && !isCurrentlyOpen) {
              e.preventDefault();
              e.stopImmediatePropagation();
              var targetSelector = $currentDropdown.attr('data-target') || $currentDropdown.attr('href');
              var $targetCollapse = $(targetSelector);
              setTimeout(function () {
                if (window.bootstrap && window.bootstrap.Collapse && $targetCollapse.length) {
                  var collapseInstance = window.bootstrap.Collapse.getInstance($targetCollapse[0]);
                  if (!collapseInstance) {
                    collapseInstance = new window.bootstrap.Collapse($targetCollapse[0], { toggle: false });
                  }
                  collapseInstance.show();
                  $currentDropdown.removeClass('collapsed').attr('aria-expanded', 'true');
                }
                else {
                  $currentDropdown[0].click();
                }
              }, 200);
            }
          })
          .on('shown.bs.collapse.authorsDropdown', '.authors-area .collapse, .block-authors-list .collapse', function () {
            var $area = $(this).closest('.authors-area, .block-authors-list');
            $area.find('.multiple-authors-dropdown').removeClass('collapsed').attr('aria-expanded', 'true');
          })
          .on('hidden.bs.collapse.authorsDropdown', '.authors-area .collapse, .block-authors-list .collapse', function () {
            var $area = $(this).closest('.authors-area, .block-authors-list');
            var hasOthersOpen = $('.authors-area .collapse.show, .authors-area .collapse.collapsing, .block-authors-list .collapse.show, .block-authors-list .collapse.collapsing').not(this).length > 0;
            var $articleMenuNav = $('.region-sidebar-first .menu--article-news .nav-list-wrapper');

            $area.find('.multiple-authors-dropdown').addClass('collapsed').attr('aria-expanded', 'false');

            if (!hasOthersOpen) {
              $area.css({ 'z-index': '', 'position': '' });
              if ($articleMenuNav.length) {
                $articleMenuNav.css({ 'z-index': '' });
              }
            }
          })
          .on('click.authorsDropdown', '.authors-area .collapse.show, .authors-area .collapse.collapsing, .block-authors-list .collapse.show, .block-authors-list .collapse.collapsing', function (e) {
            if ($(e.target).is('.collapse.show, .collapse.collapsing')) {
              var $collapse = $(this);
              var $dropdown = $collapse.closest('.authors-area, .block-authors-list').find('.multiple-authors-dropdown');
              if ($dropdown.length) {
                $dropdown.click();
              }
            }
          })
          .on('click.authorsDropdown', '.authors-area .collapse.show .card, .authors-area .collapse.collapsing .card, .block-authors-list .collapse.show .card, .block-authors-list .collapse.collapsing .card', function (e) {
            e.stopPropagation();
          })
          .on('click.authorsDropdown', function (e) {
            var $target = $(e.target);
            var $authorsArea = $target.closest('.authors-area, .block-authors-list');

            if ($target.closest('.multiple-authors-dropdown').length) {
              return;
            }

            if (!$authorsArea.length) {
              $('.authors-area .collapse.show, .authors-area .collapse.collapsing, .block-authors-list .collapse.show, .block-authors-list .collapse.collapsing').each(function () {
                var $collapse = $(this);
                var $dropdown = $collapse.closest('.authors-area, .block-authors-list').find('.multiple-authors-dropdown');
                if ($dropdown.length) {
                  $dropdown.click();
                }
              });
            }
          });
      });
      
      $(once('authors-button', '.block-authors-list .card button, .authors-area .card button', context)).on('click', function () {
        var $button = $(this);
        var $collapse = $button.closest('.collapse');
        var $dropdown = $collapse.closest('.authors-area, .block-authors-list').find('.multiple-authors-dropdown');
        if ($dropdown.length) {
          $dropdown.click();
        }
      });

      //open sidebar
      $(once('open-sidebar', '.region-footer-right-column .block-menu h5, .region-sidebar-first .block-menu h2, .block-medic-menu h2, #block-location-menu, #article-news-title, .region-sidebar-first .block-search-left-filter h2')).on('click', function () {
        var parent = $(this).parent('.is-expanded');

        $('.is-expanded').not(parent).removeClass('is-expanded');
        $(this).parent().toggleClass('is-expanded');

        //sidebar open class for back button

        //stop scroll
        if (!$(event.target).is('.region-footer-right-column .block-menu h5')) {
          if ($(this).closest('.region-sidebar-first').hasClass('is-open')) {
            bodyScrollable(false);
          } else {
            bodyScrollable(true);
          }
        }
      });
      $(document).ready(function () {
        $('header .navigation').css('visibility', 'visible').css('opacity', '1');
        $('header .navigation ul').css('visibility', 'visible').css('opacity', '1');
        // $('#block-regina-maria-content').css('visibility', 'visible').css('opacity', '1');
        $('nav#block-useraccountdental').css('visibility', 'visible').css('opacity', '1');
        $('#block-regina-maria-locationsdesktopmenu').css('visibility', 'visible').css('opacity', '1');
        $('#city-filter').css('visibility', 'visible').css('opacity', '1');
        // $('.rezultate-analize').css('visibility', 'visible').css('opacity', '1');
        $('.block-dropdown-language').css('visibility', 'visible').css('opacity', '1');
        $('.region-header:not(.desktop_locations_menu)').css('visibility', 'visible').css('opacity', '1');

        $('.region-footer-right-column .block-menu').each(function () {
          if ($(this).children('h5').hasClass('sr-only')) {
            $(this).addClass('is-expanded');
          }
        });
        $('.investigatii_blocks').css('opacity', 1).css('visibility', 'visible');
      });

      $('.edu-search--icon', context).on('click', function () {
        let filterBlock = $('.path-articole-medicale #block-educategories + .block');
        let eduTitle = $('.edu-title');
        $('.block-edu-categories .menu--simple-mega-menu').addClass('is-menu-open');
        bodyScrollable(false);
        if ($(window).width() < 1225) {
          $(filterBlock).addClass('mobile-filter-top');
          $('.block-views-exposed-filter-blockedu-main-dental').addClass('mobile-filter-top');
          $(eduTitle).addClass('mobile-title-top');
          $('#block-educategories .menu--simple-mega-menu').addClass('mobile-content-top');
        }
        if ($('#block-educategories .menu--simple-mega-menu').hasClass('is-menu-open')) {
          $('.mobile-filter-top').css('display', 'block');
          // $(document).find($('.region-content-top')).css('z-index', '1');
          // $(document).find($('.header')).css('z-index', '1');
          $('body').css('position', 'relative');
          $('#block-educategories').show();
          // $(document).find($('.header')).css('display', 'none').css('transform', 'translateY(-60px)');
          $(document).find($('body.layout-two-sidebars')).css('background', 'transparent');
        }
        // Focus first input in search block
        let form = $('#views-exposed-form-edu-main, #views-exposed-form-edu-main-dental');
        form.find('input[name="cauta"]').focus();
      });

      $('.edu-menu--search-toggler', context).on('click', function () {
        $(this).parents('.edu-menu--search').toggleClass('is-open');
        focusInput($(this).parents('.edu-menu--search'));
      });

      $('.menu--simple-mega-menu > .menu--toggler', context).on('click', function () {
        if ($('.menu--simple-mega-menu').hasClass('is-open')) {
          bodyScrollable(true);
        } else {
          bodyScrollable(false);
        }
      });

      //phone popup stop accordion toggle
      $(once('stop-accordion', '.accordion .popup', context)).on('click', function () {
        event.stopPropagation();
      });

      // this timeout ensures proper detection of input values also on browser back/forward
      setTimeout(function () {
        // on ready add class to parent if input value not empty
        $('.js-form-item', context).each(function () {
          var formGroupElement = $(this);

          if (formGroupElement.find('.form-control').val()) {
            formGroupElement.addClass('has-content');
          }
        });
      }, 1);

      $('.js-form-item .form-control', context).focus(function () {
        $(this).closest('.js-form-item').addClass('has-content');
        $(this).closest('.js-form-item').addClass('is-focused');
      });

      $('.js-form-item .form-control', context).blur(function () {
        $(this).closest('.js-form-item').removeClass('is-focused');
        if ($(this).val()) {
          $(this).closest('.js-form-item').addClass('has-content');
        } else {
          $(this).closest('.js-form-item').removeClass('has-content');
        }
      });

      $('.js-form-type-date .form-control', context).change(function () {
        if ($(this).val()) {
          $(this).closest('.js-form-item').addClass('has-content');
        } else {
          $(this).closest('.js-form-item').removeClass('has-content');
        }
      });

      // votes toggle
      $('.field-votes').click(function () {
        $(this).toggleClass('extended');
      });

      // full calendar toggle
      $('.carousel-toggler', context).click(function () {
        $('.carousel').toggleClass('extended');
      });

      if (isMobile()) {
        if ($('.js-form-type-select').find('[name="locatie"]').length) {
          $('[name="locatie"]').each(function () {
            checkLocationSelect($(this));
          });

          $(once('check-location', '[name="locatie"]')).on('change', function () {
            checkLocationSelect($(this));
          });
        }
      }

      $('.views-exposed-form.bef-exposed-form .ui-autocomplete-input', context).on('autocompleteselect', function () {
        var elem = $(this);
        setTimeout(function () {
          elem.blur();
        }, 15);
      });

      $(once('submit-autocomplete', '.views-exposed-form.bef-exposed-form .ui-autocomplete-input')).on('change', function () {
        $(this).parents('form').find('.js-form-submit').click();
      });

      $(once('cookie-show', '.cookie-show')).on('click', function (e) {
        e.preventDefault();
        __ucCmp.showSecondLayer();
      });
      function scrollToElement($element) {
        let not_scrollable = ['#cauta'];
        if (!not_scrollable.includes($element)) {
          if (window.innerWidth < 720) {
            // Check if we have the sidebar opened.
            if ($('#block-conditionssections nav').hasClass('is-expanded')) {
              $('#block-conditionssections nav').removeClass('is-expanded');
              sidebarLeftNav.removeClass('is-open');
            }
            bodyScrollable(true);
            $('html, body').stop(true, false).animate({
              scrollTop: $($element).offset().top + -80,
            }, 1000);
          } else {
            $('html, body').stop(true, false).animate({
              scrollTop: $($element).length !== 0 ? $($element).offset().top + -80 : 0,
            }, 1000);
          }
        }
      }

      $(document).on('click', 'a[href*="#"]', function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          && location.hostname == this.hostname) {
          // Get the anchor target from the url
          var $href = $.attr(this, 'href');
          var $toggle = $.attr(this, 'data-toggle');
          var $slide = $.attr(this, 'data-slide');
          // Do not scroll for elements that have data-toggle or data-slide set.
          if (typeof $toggle === 'undefined' && $slide === 'undefined') {
            var $target = $href.split('#');
            if ($('#' + $target.pop()) !== undefined) {
              scrollToElement('#' + $target.pop());
            }

          }
        }
      });

      $('.form-type-webform-document-file div.form-check input:checkbox, .form-type-managed-file div.form-check input:checkbox').unbind('change').change(
        function () {
          $('.form-type-webform-document-file input[type=submit].file-remove-button, .form-type-managed-file input[type=submit].file-remove-button').mousedown();
        });

      $(document).ready(function () {
        // Get current url.
        var $href = location.href;
        if ($href.indexOf('#') >= 0) {
          var $target = $href.split('#');
          var $anchor = '#' + $target.pop();
          if ($($anchor).length !== 0) {
            scrollToElement($anchor);
          }
        }

      });

      $(document, context).ready(function () {
        var $component = $('.paragraph--mobile.paragraph--type--component-campaign-pediatrics,  .paragraph--mobile.paragraph--type--component-vaccine-stocks', context);

        makeItemVisible($component, '.form-radios', '.form-row .form-group .fieldset-wrapper div.js-form-item input[checked="checked"] + label');
      });

      // analyses results page - confirmation form
      $(document).ready(function () {
        let confirmContainer = $('.confirm-container');
        let fieldGroups = $(confirmContainer).find('.group');
        for (let group of fieldGroups) {
          let counter = 0;
          let fields = $(group).find('.item');
          for (let item of fields) {
            if ($(item).html() === '') {
              counter += 1;

              if ($(item).prev() !== null && $(item).prev().html() !== undefined && ($(item).prev().html()).indexOf(':') !== -1) {
                $(item).prev().empty();
              }
            }
          }

          if (fields.length === counter) {
            $(group).remove();
          }
        }
      });

      // search block
      $(document).ready(function () {
        let keywordsContainer = $('.path-rezultate-cautare .layout-main-wrapper .searched-keys-container');
        var searchLgBreakpoint = 992;

        function applySearchKeywordPaddingLeft() {
          var $kw = $('.path-rezultate-cautare .layout-main-wrapper .searched-keys-container');
          var $si = $('.path-rezultate-cautare .layout-main-wrapper .search-form .form-type-search');
          if (!$kw.find('.keyword').length) {
            return;
          }
          if ($(window).width() < searchLgBreakpoint) {
            $si.css('padding-left', $kw.find('.keyword').first().outerWidth() + 20 + 'px');
          } else {
            $si.css('padding-left', $kw.width() + 30 + 'px');
          }
        }

        // min-height: același resize ca padding-ul; offset 20 sub 1225px, 30 de la 1225 în sus 
        function applySearchFieldsetMinHeight() {
          var $kw = $('.path-rezultate-cautare .layout-main-wrapper .searched-keys-container');
          var $si = $('.path-rezultate-cautare .layout-main-wrapper .search-form .form-type-search');
          if (!$si.length || !$kw.length) {
            return;
          }
          var extra = $(window).width() < 1225 ? 20 : 30;
          $si.css('min-height', $kw.height() + extra + 'px');
        }

        function applySearchResultsLayout() {
          applySearchKeywordPaddingLeft();
          applySearchFieldsetMinHeight();
        }

        applySearchResultsLayout();
        $(window).off('resize.searchResultsLayout').on('resize.searchResultsLayout', window.debounce(applySearchResultsLayout, 150));
        for (let block of $('div[class^=view-id-search]')) {
          if ($.trim($(block).html()) === '') {
            $(block).hide();
          }
        }

        // fix search block with no keywords
        if (!keywordsContainer.length) {
          let searchForm = $('.path-rezultate-cautare .main-content .search-block-form');
          $('.path-rezultate-cautare .region-content-top').append('<div class="block block-search block-search-form-block"></div>');
          $('.path-rezultate-cautare .region-content-top .block-search').append(searchForm);
        }

        if ($(window).width() < 1225) {
          // mobile menu slider
          let initialPosition = 0;
          let prevLeft = 0;
          let searchMenu = $('.path-rezultate-cautare .layout-main-wrapper .search-menu');
          let swipeLimit = 0;
          let navItems = $('.path-rezultate-cautare .layout-main-wrapper .search-menu .nav-item');
          for (let i = 0; i < navItems.length - 2; i++) {
            swipeLimit += $(navItems[i]).outerWidth() + parseInt($(navItems[i]).css('margin-right'));
          }

          $(searchMenu).css('position', 'relative');

          $(searchMenu).on('touchstart', function (e) {
            let touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            initialPosition = touch.pageX;
            prevLeft = parseInt($(this).css('left'));
            if (isNaN(prevLeft)) {
              prevLeft = 0;
            }
          }, { passive: true });

          $(searchMenu).on('touchmove', function (e) {
            let moveTouch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            let left = prevLeft - (initialPosition - moveTouch.pageX);
            if (left < 0 && -left <= swipeLimit) {
              $(this).css('left', left);
            }
          }, { passive: true });
        }
      });

      $(document).ready(function () {
        function setEqualSlideDimensions(slickElement) {
          let maxWidth = 0;

          // Reset heights to get natural height first
          slickElement.find('.slick-slide').css('width', 'auto');
          // Find the tallest slide
          slickElement.find('.paragraph--type--medic').each(function () {
            const thisWidth = $(this).outerWidth();
            if (thisWidth > maxWidth) {
              maxWidth = thisWidth;
            }
          });
          // Apply the tallest height to all slides
          slickElement.find('.slick-slide').css('width', maxWidth + 'px');
        }
        let megaMenu = $('#block-educategories .mega-menu-wrapper.is-active');
        let filterBlock = $('.path-articole-medicale #block-educategories + .block'),
          menuItem = $('#block-educategories .menu-item.has-hover');

        if ($('.path-articole-medicale').hasClass('page-view-edu')) {
          filterBlock = $(filterBlock).find('form');
          megaMenu = $(this).find('.submenu');
        } else if (!filterBlock.length) {
          filterBlock = $('.node--type-article #block-educategories + .block-views-exposed-filter-blockedu-main');
          megaMenu = $(this).find('.submenu');
        }
        if ($('body').hasClass('path-dental')) {
          if ($('.path-articole-medicale').hasClass('page-view-edu')) {
            filterBlock = $(filterBlock).find('form');
          } else if (!filterBlock.length) {
            filterBlock = $('.node--type-article #block-educategories + .block-views-exposed-filter-blockedu-main-dental');
          }
        }
        let filterBlockTop = $(filterBlock).css('top'),
          menuItemPb = $(menuItem).find('.mega-menu-wrapper').css('padding-bottom');

        $(menuItem).mouseenter(function () {

          if ($(window).width() > 991) {
            $(this).siblings().addClass('hover-inactive');

            megaMenu.addClass('is-active');
            $(filterBlock).css('top', parseInt($(megaMenu).height()) - parseInt($(filterBlock).height()) + 'px');
            $(filterBlock).css('z-index', '1003');
            $(megaMenu).css('padding-bottom', $(filterBlock).height());
            $(megaMenu).css({
              'opacity': 1,
              'display': 'block',
            });
          }
        });

        $(menuItem).mouseleave(function () {
          $(this).siblings().removeClass('hover-inactive');
          if ($(window).width() > 991) {
            if (!$('.path-articole-medicale #block-educategories + .block:hover').length &&
              !$('.node--type-article #block-educategories + .block:hover').length) {
              $(filterBlock).css('top', filterBlockTop);
              $(filterBlock).css('z-index', 'unset');
              $(menuItem).find('.mega-menu-wrapper').css('padding-bottom', menuItemPb);
              $(menuItem).find('.mega-menu-wrapper').removeClass('is-active');

              $(menuItem).find('.mega-menu-wrapper').css({
                'opacity': 0,
                'display': 'none',
              });
            }
          }
        });

        $(filterBlock).mouseleave(function () {
          if ($(window).width() > 991) {
            let megaMenu = $('#block-educategories .mega-menu-wrapper.is-active');
            if (megaMenu.length && !$('#block-educategories .menu-item.has-hover:hover').length) {
              $(filterBlock).css('top', filterBlockTop);
              $(filterBlock).css('z-index', 'unset');
              $(menuItem).find('.mega-menu-wrapper').css('padding-bottom', menuItemPb);
              $(menuItem).find('.mega-menu-wrapper').removeClass('is-active');

              $(megaMenu).css({
                'opacity': 0,
                'display': 'none',
              });
            }
          }
        });

        $('.small .scale > li > span').each(function (index) {
          $(this).css('left', (36 - $(this).outerWidth()) / 2 + 'px');
        });

        $('.big .scale > li > span').each(function (index) {
          $(this).css('left', (56 - $(this).outerWidth()) / 2 + 'px');
        });

        let eduTitle = $('.edu-title');
        $('.close-edu-nav', context).click(function () {
          if ($(window).width() < 1225) {
            $(filterBlock).removeClass('mobile-filter-top');
            $('.block-views-exposed-filter-blockedu-main-dental').removeClass('mobile-filter-top');
            $(eduTitle).removeClass('mobile-title-top');
            $('#block-educategories .menu--simple-mega-menu').removeClass('mobile-content-top');
            $('.menu--simple-mega-menu').removeClass('is-menu-open');
            $('.menu-item.is-open').removeClass('is-open');
            bodyScrollable(true);
            $(eduTitle).show();
            $(filterBlock).show();
          }
        });

        $('#block-educategories .menu-item--toggler', context).click(function () {
          if ($(window).width() < 1225) {
            $(filterBlock).addClass('mobile-filter-top');
            $(eduTitle).addClass('mobile-title-top');
            $('#block-educategories .menu--simple-mega-menu').addClass('mobile-content-top');

            if ($(this).closest('.is-open').length) {
              $(eduTitle).hide();
              $(filterBlock).hide();
            } else {
              $(eduTitle).show();
              $(filterBlock).show();
            }
          }
        });

        //Servicii Carousel
        var serviciiContainer = $('.paragraph--type--servicii-carousel .slick__slider', context);
        if (typeof serviciiContainer !== 'undefined') {
          if ((serviciiContainer).length) {
            if ($(window).width() > 991) {

              serviciiContainer.slick('slickSetOption',
                {
                  infinite: false,
                  slidesToScroll: 1,
                  slidesToShow: 4.5,
                  arrows: true,
                  outerEdgeLimit: true,
                  variableWidth: false,
                });
            }

            if ($(window).width() < 768) {
              $(serviciiContainer).slick('slickSetOption', {
                slidesToScroll: 1,
                slidesToShow: 1.3,
              });
            }
          }
        }
        //testimonials Slider

        var testimonialContainer = $('.paragraph--type--new-testimonials .slick--field-testimonial-component .slick__slider', context);
        if (typeof testimonialContainer !== 'undefined') {
          if ((testimonialContainer).length) {
            if ($(window).width() > 991) {

              testimonialContainer.slick('slickSetOption',
                {
                  slidesToScroll: 1,
                  speed: 1000,
                  slidesToShow: 1.25,
                  outerEdgeLimit: true,
                  variableWidth: false,
                });
            }

            if ($(window).width() < 768) {
              testimonialContainer
                .slick('slickSetOption', {
                  speed: 1000,
                  slidesToShow: 1.1,
                });
            }
          }
        }
        // Medics slider on maternity lp
        var $slickContainer = $('.paragraph--type--component-medics.style--modern .slick-initialized', context),
          slickSlider = $('.paragraph--type--component-medics.style--modern .slick__slider', context),
          slickSlide = $('.paragraph--type--component-medics.style--modern .slick__slider .slick__slide', context);

        if (typeof $slickContainer !== 'undefined') {
          if (($slickContainer).length) {
            if ($(window).width() > 991) {
              let slideWidth = ($(slickSlider).width()) / 3 + 'px';
              $(slickSlide).css('width', slideWidth);

              $slickContainer.slick('slickSetOption',
                {
                  slidesToScroll: 3,
                  speed: 1000,
                  slidesToShow: 3,
                  outerEdgeLimit: true,
                  variableWidth: false,
                });
            }
            if ($(window).width() < 600) {
              $slickContainer
                .slick('slickSetOption', {
                  slidesToScroll: 1,
                  speed: 1000,
                  slidesToShow: 1.5,
                  outerEdgeLimit: true,
                  variableWidth: false,
                });
            }
          }
        }
        setEqualSlideDimensions($('.paragraph--type--component-medics .slick--field-medics'));
        var medicsHomepageContainer = $('.medics-homepage ul.slick-initialized', context);
        if (typeof medicsHomepageContainer !== 'undefined') {
          if ((medicsHomepageContainer).length) {
            if ($(window).width() < 768) {
              medicsHomepageContainer.slick('slickSetOption', {
                slidesToScroll: 1,
                slidesToShow: 2.5,
              });
            }
          }
        }
      });
      // handle anchor click to form "vaccinare internationala"
      $(document).ready(function handleVaccineFormAnchor() {
        var $vaccineForm = $('.webform-submission-vaccinare-internationala-form');
        var componentId = getComponentId($vaccineForm);

        if (!componentId) {
          return;
        }

        var $vaccineFormAnchors = $('.field--name-field-cta').find('a[href="' + componentId + '"]');

        $vaccineFormAnchors.on('click', handleCtaClick);

        function getComponentId($vaccineForm) {
          if (!$vaccineForm.length) {
            return '';
          }

          var $fieldItemParents = $vaccineForm.parents('.field__item');

          if (!$fieldItemParents.length) {
            return '';
          }

          /** search for component id */
          for (var i = 0; i < $fieldItemParents.length; i++) {
            var $currentParent = $fieldItemParents.eq(i);
            var idValue = $currentParent.attr('id');

            if (idValue) {
              return '#' + idValue;
            }
          }

          return '';
        }

        function handleCtaClick(event) {
          event.preventDefault();

          var vaccineFormOffset = $('.webform--vaccinare_internationala').offset().top;

          $(window).scrollTop(vaccineFormOffset);
        }
      });

      // handle title size on Brand campaign
      $(document).ready(function handleCustomFontTitles() {
        /* mark campaign body */
        if ($('body').hasClass('brand-campaign-listing')) {
          if (!$('.block-system-breadcrumb-block').length) {
            $('body').addClass('no-brand-breadcrumbs');
          }
        }

        var $brandCampaignPage = $('body.brand-campaign, body.brand-campaign-listing, body.brand-campaign-story, body.brand-story-2023', context);

        if (!$brandCampaignPage.length) {
          return;
        }

        var $customTitles = $brandCampaignPage.find('.portrait-font');

        for (var i = 0; i < $customTitles.length; i++) {
          var $currentCustomTitle = $customTitles.eq(i);

          handleCustomTitle($currentCustomTitle);

          $(window).on('resize', function () {
            handleCustomTitle($currentCustomTitle);
          });
        }
      });
      $(document).ready(handleDescription('.paragraph--type--component-image-banner', '.field--name-field-box-description p', context));
      // handle section-lab-links (links component) - behave first link item as title
      $(document).ready(function handleLabLinksTitle() {
        if ($(window).width() > 767.98) {
          return;
        }

        let $targetSection = $('.node-laborator', context);
        if (!$targetSection.length) {
          return;
        }

      });
    },
  };
  // Call the function to add the "is-active" class to links based on the current URL.
  addActiveClassToLinks();

  // Helper: position the datepicker using viewport coordinates.
  function positionDatepicker(input, inst) {
    var rect = input.getBoundingClientRect();
    var $dp = $(inst.dpDiv);

    // Make sure it's attached to body (avoids clipping by ancestors).
    if (!$dp.parent().length) {
      $dp.appendTo(document.body);
    }

    // Ensure it's fixed to the viewport.
    $dp.css({ position: "fixed", zIndex: 10000 });

    // Calculate final position (prefer below, clamp to viewport).
    var dpW = $dp.outerWidth();
    var dpH = $dp.outerHeight();
    var vw  = window.innerWidth;
    var vh  = window.innerHeight;

    var padding = 8; // breathing room from edges

    var top = rect.bottom; // try below
    // If it would overflow bottom, flip above if there’s more room.
    if (top + dpH + padding > vh && rect.top - dpH - padding >= padding) {
      top = rect.top - dpH; // above
    }

    var left = rect.left;
    // Clamp horizontally
    if (left + dpW + padding > vw) left = vw - dpW - padding;
    if (left < padding) left = padding;
    if (top + dpH + padding > vh) top = vh - dpH - padding; // final clamp
    if (top < padding) top = padding;

    $dp.css({ top: top, left: left });
  }

  Drupal.behaviors.initDatePicker = {
    attach: function (context, settings) {
      var baseOptions = {
        showButtonPanel: false,
        changeMonth: true,
        changeYear: true,
        showOtherMonths: true,
        yearRange: "-120:+30",
        dateFormat: "yy-mm-dd",
        selectOtherMonths: true,
        // Keep the widget out of fixed containers
        appendTo: "body",
        // Disable animation (mobile jank)
        showAnim: ""
      };

      $(once("init-datepicker", ".jquery-datepicker", context)).each(function () {
        var $input = $(this);

        // Build per-input options (respect min/max attributes if present).
        var opts = $.extend({}, baseOptions);
        var minDate = $input.attr("date_date_min");
        var maxDate = $input.attr("date_date_max");
        if (minDate && minDate !== "") opts.minDate = minDate;
        if (maxDate && maxDate !== "") opts.maxDate = maxDate;

        // Namespaced reflow handlers unique per instance so we can unbind cleanly.
        var ns = ".dpfix-" + Math.random().toString(36).slice(2);

        opts.beforeShow = function (input, inst) {
          // Wait for the dp DOM to exist, then position.
          setTimeout(function () { positionDatepicker(input, inst); }, 0);

          // Reposition on viewport changes.
          $(window)
            .on("scroll" + ns, function () { positionDatepicker(input, inst); })
            .on("resize" + ns, function () { positionDatepicker(input, inst); })
            .on("orientationchange" + ns, function () { positionDatepicker(input, inst); });
        };

        opts.onChangeMonthYear = function (yy, mm, inst) {
          setTimeout(function () { positionDatepicker(inst.input[0], inst); }, 0);
        };

        opts.onClose = function () {
          $(window).off(ns);
        };

        $input.datepicker(opts);
      });
    }
  };

  // Optional: ensure high stacking on some mobile browsers.
  $(function () {
    var css = ".ui-datepicker{z-index:10000!important;}";
    var style = document.createElement("style");
    style.type = "text/css";
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  });
  Drupal.behaviors.birthDateRange = {
    attach(context) {
      const selector = '#edit-birth-date.jquery-datepicker';
      $(once('birthDateRange', selector, context)).each(function () {
        // Reset maxDate to today +9 months
        $(this).datepicker('option', {
          maxDate: '+9m',
          yearRange: (new Date()).getFullYear() + ':' + (new Date().getFullYear() + 1),
        });
      });
    },
  };

  Drupal.behaviors.choosenMousePad = {
    attach(context) {
      // Prevent chosen dropdown from scrolling the page.
      $('.chosen-results').on('wheel', function (e) {
        e.stopPropagation();
      });
    },
  };

  // accordion scrolling
  Drupal.behaviors.accordion_component = {
    attach(context) {
      // Find all trigger elements that haven’t been processed yet.
      $(once('accordion_component', '[data-target^="#body-"], [data-target^="#collapse"]', context)).each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();

          // 1. Identify the target collapse element
          var selector = $(this).attr('data-target');
          var $collapse = $(selector);
          if (!$collapse.length) {
            console.warn('Accordion target not found:', selector);
            return;
          }

          // 2. Toggle it via Bootstrap Collapse
          //    (assumes bootstrap JS is loaded as window.bootstrap)
          var instance = window.bootstrap.Collapse.getInstance($collapse[0]);
          if (!instance) {
            instance = new window.bootstrap.Collapse($collapse[0], { toggle: false });
          }
          instance.toggle();

          // 3. After the panel begins expanding, adjust scroll if needed
          setTimeout(() => {
            // Look at all previously expanded panels
            $collapse
              .closest('.accordion-item')
              .prevAll('.accordion-item')
              .each(function () {
                var $prev = $(this).find('.accordion-collapse.show');
                if ($prev.length && $prev.height() > $(window).height()) {
                  $('html,body').animate({
                    scrollTop: $(window).scrollTop() - $prev.innerHeight(),
                  }, 500);
                  return false; // break out of .each()
                }
              });
          }, 200);
        });
      });
    },
  };
  // secondary menu mobile fix.
  Drupal.behaviors.submenu_edu = {
    attach(context) {
      // Only run this behavior once per page.
      once('mobile-navigation', 'body', context).forEach(() => {
        // Only activate on narrow viewports.
        if ($(window).width() > 1376) {
          return;
        }
        // Your mobile nav wrapper.
        var $mobileNavigation = $(
          '#block-indexmenu, ' +
          '#block-meniulpaginiidemedici, ' +
          '#block-locatii-menu, ' +
          '#article-news-title, ' +
          '#block-locatii, ' +
          '.menu--locatii, ' +
          '.menu--article-news',
          context,
        );
        if (!$mobileNavigation.length) {
          return;
        }
        if (isMobile()) {
          // Mark body so you can style it.
          $('body').addClass('has-navigation-mobile');
        }
        // Highlight any parent of an active submenu.
        $mobileNavigation
          .find('.nav-item')
          .has('.menu .active')
          .addClass('expanded-active');

        // Create the submenu container once.
        var $submenuContainer = $('<div class="submenu-container" />')
          .appendTo($mobileNavigation);

        // Handle clicks on togglers.
        $mobileNavigation
          .find('.menu-item--expanded > .nav-link, .menu-item--toggler')
          .on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var $thisLink = $(this);
            var $card = $thisLink.closest('.nav-item');
            var $submenu = $card.find('.menu').clone(true);

            // Special case for “edu” pages
            if (!$submenu.length) {
              $submenu = $card
                .find('.mega-menu-wrapper .menu')
                .clone(true);
            }

            // Toggle open/closed
            var isOpen = $thisLink.toggleClass('is-open').hasClass('is-open');
            if (!isOpen) {
              $submenuContainer.empty();
              $mobileNavigation.find('.nav').removeClass('submenu-visible');
            } else {
              $submenuContainer
                .empty()
                .append($submenu);
              $mobileNavigation.find('.nav').addClass('submenu-visible');
            }

            // Close search if open
            $('.search_header').removeClass('is-open');
          });

        // If one was already active on load, open it.
        var $expanded = $mobileNavigation.find('.expanded-active');
        if ($expanded.length) {
          // scroll the nav so it’s visible
          makeItemVisible($mobileNavigation, '.nav', '.expanded-active');

          setTimeout(() => {
            $expanded.find('.nav-link').trigger('click');
            makeItemVisible($submenuContainer, '.menu', '.active');
          }, 0);
        } else {
          makeItemVisible($mobileNavigation, '.nav', '.active');
        }
      });
    },
  };
  Drupal.behaviors.mymoduleChosenReinit = {
    attach: function (context, settings) {
      // Find all selects that haven't actually run .chosen() yet.
      $(document).ready(function() {
        once('mymodule-chosen', 'select', context)
          .forEach(function (el) {
            var $element = $(el);
            if ($element.hasClass('search-api-sorts')) {
              return;
            }
            var $el = $element.attr('id');
            // Initialize Chosen, then mark as initialized
            $('#' + $el).chosen();
          });
      });
    }
  };
  $(document).ready(function(){
  // Fallback for non-Drupal ajax calls
    $(document).ajaxComplete(function () {
      Drupal.behaviors.mymoduleChosenReinit.attach(document, Drupal.settings);
    });
  });
  $(document).ready(function () {
    $('.paragraph--type--component-campaign-tab .nav-pills .nav-link').on('click', function (e) {
      e.preventDefault();

      $(this).closest('.nav').find('.nav-link').removeClass('active');
      $(this).addClass('active');

      var targetId = $(this).attr('href');

      $(this).closest('.paragraph--type--component-campaign-tab')
        .find('.tab-pane')
        .removeClass('active show');

      $(targetId).addClass('active show');
    });
    $('.region-header .search_header span').text('');
    $('.region-header .user-account a').text('');
    $('.region-header .logo a').text('');
  });
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.field--name-field-grade').forEach(function(gradeEl) {
      var votesInfo = gradeEl.closest('.votes-info');
      if (!votesInfo) return;
      var votesRates = votesInfo.querySelector('.votes-rates');
      if (!votesRates) return;
      var infoTrigger = gradeEl.querySelector('.info_recenzii');

      const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

      if (isMobile) {
        var toggleVotesRates = function (e) {
          e.stopPropagation();
          votesRates.style.display = (votesRates.style.display === 'block') ? 'none' : 'block';
        };

        gradeEl.addEventListener('click', toggleVotesRates);
        if (infoTrigger) {
          infoTrigger.addEventListener('click', toggleVotesRates);
        }

        document.addEventListener('click', function (e) {
          if (!votesInfo.contains(e.target)) {
            votesRates.style.display = 'none';
          }
        });
      } else {
        votesInfo.addEventListener('mouseenter', function () {
          votesRates.style.display = 'block';
        });
        votesInfo.addEventListener('mouseleave', function () {
          votesRates.style.display = 'none';
        });
      }
    });
  });
})(jQuery, Drupal);

/**
 * Keep wrapped dental testimonial cards independent of container width.
 */
(function ($, Drupal, once) {
  'use strict';

  var selector = '.paragraph--type--background-wrapper .paragraph--type--dental-testimonial .slick__slider';

  function useFixedCardSettings(settings) {
    settings.variableWidth = true;
    settings.slidesToShow = 1;
    settings.slidesToScroll = 1;
    settings.centerMode = false;
    settings.centerPadding = '0px';

    (settings.responsive || []).forEach(function (breakpoint) {
      if (breakpoint.settings && breakpoint.settings !== 'unslick') {
        useFixedCardSettings(breakpoint.settings);
      }
    });

    return settings;
  }

  function configureSlider(slider) {
    var $slider = $(slider);

    function applySettings() {
      if (!$slider.hasClass('slick-initialized')) {
        return;
      }

      var slick = $slider.slick('getSlick');
      var settings = useFixedCardSettings(
        $.extend(true, {}, slick.originalSettings || slick.options)
      );
      var currentSlide = slick.currentSlide;

      $slider.slick('unslick');
      $slider.data('slick', settings);
      $slider.slick(settings);
      $slider.slick('slickGoTo', currentSlide, true);
    }

    if ($slider.hasClass('slick-initialized')) {
      applySettings();
    } else {
      $slider.one('init.dentalTestimonialFixedCards', function () {
        window.requestAnimationFrame(applySettings);
      });
    }
  }

  Drupal.behaviors.dentalTestimonialFixedCards = {
    attach: function (context) {
      once('dental-testimonial-fixed-cards', selector, context)
        .forEach(function (slider) {
          configureSlider(slider);
        });
    }
  };
})(jQuery, Drupal, once);
